import React, { useCallback, useState } from "react";
import { Box, Button, IconButton, InputBase } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { MdMenu } from "react-icons/md";
import Logo from "../Logo/Logo";
import PropTypes from "prop-types";
import styles from "./DashboardHeader.module.css";

const DashboardHeader = ({ isCreateMode = false, onMenuClick }) => {
  const navigate = useNavigate();
  const [inputValue, setInputValue] = useState("");
  const [profileImage, setProfileImage] = useState("/img1@2x.png");

  const handleCreateClick = useCallback(() => {
    navigate("/create");
  }, [navigate]);

  const handleCancelClick = useCallback(() => {
    navigate("/dashboard");
  }, [navigate]);

  const handleSearch = (searchValue) => {
    console.log("Searching for:", searchValue);
  };

  return (
    <Box className={styles.dashboardHeader}>
      <Box className={styles.mobileMenuIcon}>
        <IconButton onClick={onMenuClick}>
          <MdMenu size={28} />
        </IconButton>
      </Box>
      
      <Box className={styles.logoSearchWrapper}>
        <Logo 
          group="/group.svg" 
          group1="/group-1.svg" 
          onLogo2ContainerClick={() => window.location.href = "/"} 
          style={{ cursor: "pointer" }} 
        />

        {/* <Box className={styles.searchWrapper}>
          <Box className={styles.searchContainer}>
            <InputBase
              className={styles.searchInput}
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              placeholder="Search items, collections, and accounts"
              fullWidth
            />
            <IconButton className={styles.searchButton} onClick={handleSearch}>
              <AiOutlineSearch />
            </IconButton>
          </Box>
        </Box> */}
      </Box>

      <Box className={styles.actionsWrapper}>
        {isCreateMode ? (
          <Button
            variant="contained"
            className={styles.cancelButton}
            onClick={handleCancelClick}
          >
            Cancel
          </Button>
          
        ) : (
          <Button
            variant="contained"
            className={styles.createButton}
            onClick={handleCreateClick}
          >
            Create
          </Button>
        )}

        {/* <img className={styles.profileImage} src={profileImage} alt="Profile" /> */}
      </Box>
    </Box>
  );
};

DashboardHeader.propTypes = {
  isCreateMode: PropTypes.bool,
};

export default DashboardHeader;